
import React from 'react';
import { Helmet } from "react-helmet";
import chandigarhshowroom from '../img/infrastructure/chandigarh-showroom.jpg';
import mohalifactory from '../img/journey/6.jpg';
import mohalifactory1 from '../img/infrastructure/mohali-factory1.jpg';
import mohalifactory2 from '../img/infrastructure/mohali-factory2.jpg';
import mohalifactory3 from '../img/infrastructure/mohali-factory3.jpg';
import mohalifactory4 from '../img/infrastructure/mohali-factory4.jpg';
import mohalifactory5 from '../img/infrastructure/mohali-factory5.jpg';
import mohalifactory6 from '../img/infrastructure/mohali-factory6.jpg';
import mohalifactory7 from '../img/infrastructure/mohali-factory7.jpg';
import mohalifactory8 from '../img/infrastructure/mohali-factory8.jpg';
import mohalifactory9 from '../img/infrastructure/mohali-factory9.jpg';
import mohalifactory10 from '../img/infrastructure/mohali-factory10.jpg';
import mohalishowroom from '../img/infrastructure/mohali-showroom.jpg';
import ourinfrastructurebanner from '../img/infrastructure/our-infrastructure-banner.jpg';
import rajpurafactoryworking from '../img/infrastructure/rajpura-factory-working.jpg';
import rajpurafactory1 from '../img/infrastructure/rajpura-factory1.jpg';
import rajpurafactory2 from '../img/infrastructure/rajpura-factory2.jpg';
import rajpurafactory3 from '../img/infrastructure/rajpura-factory3.jpg';
import rajpurafactory4 from '../img/infrastructure/rajpura-factory4.jpg';
import rajpurafactory5 from '../img/infrastructure/rajpura-factory5.jpg';
import rajpurafactory6 from '../img/infrastructure/rajpura-factory6.jpg';
import rajpurafactory7 from '../img/infrastructure/rajpura-factory7.jpg';
import rajpurafactory8 from '../img/infrastructure/rajpura-factory8.jpg';
import rajpurafactory9 from '../img/infrastructure/rajpura-factory9.jpg';
import rajpurafactory10 from '../img/infrastructure/rajpura-factory10.jpg';

import chandigarhvideo from '../video/chandigarhvideo.mp4';
import mohalivideo from '../video/mohalivideo.mp4';

function Ourinfrastructure() {
  
  return (
<div className="page-content">
<Helmet>
        <link rel="preload" href={ourinfrastructurebanner} as="image" />
      </Helmet>
  <div
    className="sx-bnr-inr overlay-wraper bg-parallax bg-top-center"
    data-stellar-background-ratio="0.5"
    style={{
      backgroundImage:  `url(${ourinfrastructurebanner})`
    }}
  >
    <div className="overlay-main bg-black opacity-07" />
    <div className="container">
      <div className="sx-bnr-inr-entry">
        <div className="banner-title-outer">
          <div className="banner-title-name">
            <h2 className="m-tb0">Our Infrastructure</h2>
            <p>
              The state of the art manufacturing facility produces Lithium Battery Packs,
              UPS, Inverter, BSS, Solar Lighting Solutions and Battery packs for
              different applications. These products are being manufactured in our facility for
              Rajpura and Mohali locations.
            </p>
          </div>
        </div>
        
      </div>
    </div>
  </div>
  {/* INNER PAGE BANNER END */}
  {/* ABOUT COMPANY START */}
  <div className="section-full mobile-page-padding p-t80 p-b50 bg-gray">
    <div className="container">
      <div className="section-content">
        <div className="row">
          <div className="col-xl-6 col-lg-6 col-md-12">
            <div className="about-home-3 m-b30 bg-white">
              <h3 className="m-t0 m-b20 sx-tilte">Mohali Factory | Spinoff</h3>
              <p>
                Spinoff Technopark Ltd. is North India’s premier ISO and
                BIS certified plant specializing in LED manufacturing. We have over
                3000 in-house products across various applications. Our
                integrated facilities include SMT lines, production units, and a
                state-of-the-art test lab with Spectrometric analyzers, ensuring
                compliance with CE, BIS, ROHS, UL, LM80, and LM79 standards for
                top-quality LED products.
              </p>
              <ul className="list-angle-right anchor-line">
                <li>Innovative LED Manufacturing</li>
                <li>Diverse Product Applications</li>
                <li>Technological Excellence</li>
              </ul>
              {/* <div class="text-left">
                          <a href="javascript:;" class="site-button btn-half"><span>Read More</span></a>
                      </div>                                                     */}
            </div>
          </div>
          <div className="col-xl-6 col-lg-6 col-md-12">
            <div className="video-section-full-v2">
              <div
                className="video-section-full bg-no-repeat bg-cover bg-center overlay-wraper m-b30"
                style={{
                  backgroundImage: `url(${mohalifactory})`
                }}
              >
          </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  {/* ABOUT COMPANY END */}
  {/* SECTION CONTENT START */}
  <div className="section-full p-tb80 bg-white inner-page-padding">
    <div className="container-fluid2">
      <div className="section-content">
        {/* TITLE START */}
        <div className="section-head">
          <div className="sx-separator-outer separator-left">
            <div
              className="sx-separator bg-white bg-moving bg-repeat-x"
              style={{
                backgroundImage: "url(images/background/cross-line2.png)"
              }}
            >
              <h3 className="sep-line-one">Mohali Factory</h3>
            </div>
          </div>
        </div>
        {/* TITLE END */}
        <div className="work-carousel-outer">
          <div className="owl-carousel mfp-gallery project-carousel project-carousel4 owl-btn-vertical-center">
            {/* COLUMNS 1 */}
            <div className="item">
              <div className="sx-box   image-hover-block">
                <div className="sx-thum-bx">
                  <img src={mohalifactory1} alt="" />
                </div>
                <div className="sx-info  p-t20 text-white">
                  {/* <h4 class="sx-tilte m-t0"><a href="#">Interior Work Avroko</a></h4>
                          <p class="m-b0">Muscat, Sultanate of Oman</p>       */}
                </div>
               
              </div>
            </div>
            {/* COLUMNS 2 */}
            <div className="item">
              <div className="sx-box   image-hover-block">
                <div className="sx-thum-bx">
                  <img src={mohalifactory2} alt="" />
                </div>
                <div className="sx-info  p-t20 text-white">
                  {/* <h4 class="sx-tilte m-t0"><a href="#">Vilters</a></h4>
                          <p class="m-b0">Muscat, Sultanate of Oman</p>       */}
                </div>
               
              </div>
            </div>
            {/* COLUMNS 3 */}
            <div className="item">
              <div className="sx-box   image-hover-block">
                <div className="sx-thum-bx">
                  <img src={mohalifactory3} alt="" />
                </div>
                <div className="sx-info  p-t20 text-white">
                  {/* <h4 class="sx-tilte m-t0"><a href="#">Industrial Design</a></h4>
                          <p class="m-b0">Muscat, Sultanate of Oman</p>       */}
                </div>
                
              </div>
            </div>
            {/* COLUMNS 4 */}
            <div className="item">
              <div className="sx-box   image-hover-block">
                <div className="sx-thum-bx">
                  <img src={mohalifactory4} alt="" />
                </div>
                <div className="sx-info  p-t20 text-white">
                  {/* <h4 class="sx-tilte m-t0"><a href="#">House Bluprint</a></h4>
                          <p class="m-b0">Muscat, Sultanate of Oman</p>       */}
                </div>
               
              </div>
            </div>
            {/* COLUMNS 5 */}
            <div className="item">
              <div className="sx-box   image-hover-block">
                <div className="sx-thum-bx">
                  <img src={mohalifactory5} alt="" />
                </div>
                <div className="sx-info  p-t20 text-white">
                  {/* <h4 class="sx-tilte m-t0"><a href="#">Modern Bathroom</a></h4>
                          <p class="m-b0">Muscat, Sultanate of Oman</p>       */}
                </div>
                
              </div>
            </div>
            {/* COLUMNS 6 */}
            <div className="item">
              <div className="sx-box   image-hover-block">
                <div className="sx-thum-bx">
                  <img src={mohalifactory6} alt="" />
                </div>
                <div className="sx-info  p-t20 text-white">
                  {/* <h4 class="sx-tilte m-t0"><a href="#">Bellevue Project</a></h4>
                          <p class="m-b0">Muscat, Sultanate of Oman</p>       */}
                </div>
               {/* <a
                  className="mfp-link"
                  href="img/infrastructure/mohali-factory6.jpg"
                >
                  <i className="fa fa-arrows-alt" />
                </a>*/}
              </div>
            </div>
            {/* COLUMNS 7 */}
            <div className="item">
              <div className="sx-box   image-hover-block">
                <div className="sx-thum-bx">
                  <img src={mohalifactory7} alt="" />
                </div>
                <div className="sx-info  p-t20 text-white">
                  {/* <h4 class="sx-tilte m-t0"><a href="#">Bellevue Project</a></h4>
                          <p class="m-b0">Muscat, Sultanate of Oman</p>       */}
                </div>
              
              </div>
            </div>
            {/* COLUMNS 8*/}
            <div className="item">
              <div className="sx-box   image-hover-block">
                <div className="sx-thum-bx">
                  <img src={mohalifactory8} alt="" />
                </div>
                <div className="sx-info  p-t20 text-white">
                  {/* <h4 class="sx-tilte m-t0"><a href="#">Bellevue Project</a></h4>
                          <p class="m-b0">Muscat, Sultanate of Oman</p>       */}
                </div>
                
              </div>
            </div>
            {/* COLUMNS 9 */}
            <div className="item">
              <div className="sx-box   image-hover-block">
                <div className="sx-thum-bx">
                  <img src={mohalifactory9} alt="" />
                </div>
                <div className="sx-info  p-t20 text-white">
                  {/* <h4 class="sx-tilte m-t0"><a href="#">Bellevue Project</a></h4>
                          <p class="m-b0">Muscat, Sultanate of Oman</p>       */}
                </div>
              
              </div>
            </div>
            {/* COLUMNS 10 */}
            <div className="item">
              <div className="sx-box   image-hover-block">
                <div className="sx-thum-bx">
                  <img src={mohalifactory10} alt="" />
                </div>
                <div className="sx-info  p-t20 text-white">
                  {/* <h4 class="sx-tilte m-t0"><a href="#">Bellevue Project</a></h4>
                          <p class="m-b0">Muscat, Sultanate of Oman</p>       */}
                </div>
                
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  {/* SECTION CONTENT END  */}
  {/* ABOUT COMPANY START */}
  <div className="section-full mobile-page-padding p-t80 p-b50 bg-gray">
    <div className="container">
      <div className="section-content">
        <div className="row">
          <div className="col-xl-6 col-lg-6 col-md-12">
            <div className="about-home-3 m-b30 bg-white">
              <h3 className="m-t0 m-b20 sx-tilte">Rajpura Factory | Spinoff</h3>
              <p>
                Welcome to our Rajpura Plant, a cutting-edge facility integrating
                lithium battery production, UPS/Inverter products and ESS
                products for Telecom Data Center, Banking, Server Room,
                Institutions, Hospital, Hotels etc.  We specialize in
                delivering comprehensive energy storage solutions, catering to
                the evolving needs of sustainable technologies and modern living
                environments. In this plant, we also provide metal craft solutions with
                advanced powder coating facilities.
              </p>
              <ul className="list-angle-right anchor-line">
                <li>End-to-End Solutions</li>
                <li>Design Versatility</li>
                <li>Modern Innovation</li>
              </ul>
              {/* <div class="text-left">
                          <a href="javascript:;" class="site-button btn-half"><span>Lithium</span></a>
                      </div>                                                     */}
            </div>
          </div>
          <div className="col-xl-6 col-lg-6 col-md-12">
            <div className="video-section-full-v2">
              <div
                className="video-section-full bg-no-repeat bg-cover bg-center overlay-wraper m-b30"
                style={{
                  backgroundImage:
                    `url(${rajpurafactoryworking})`
                }}
              >
           </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

 {/*<div class="section-full p-tb80 bg-white inner-page-padding">
    <div class="container-fluid2">
  <div class="section-content">
      
      <div class="section-head">
          <div class="sx-separator-outer separator-left">
              <div class="sx-separator bg-white bg-moving bg-repeat-x" >
                  <h3 class="sep-line-one">Rajpura Factory</h3>
              </div>
          </div>
      </div>                   
                                     
      <div class="work-carousel-outer">
          <div class="owl-carousel mfp-gallery project-carousel project-carousel4 owl-btn-vertical-center">
              
              <div class="item">
                  <div class="sx-box   image-hover-block">
                      <div class="sx-thum-bx">
                          <img src={rajpurafactory1} alt=""/>
                      </div>
                      <div class="sx-info  p-t20 text-white">
                          
                      </div>                                           
                 </div>
              </div>
              
              <div class="item">
                  <div class="sx-box   image-hover-block">
                      <div class="sx-thum-bx">
                          <img src={rajpurafactory2} alt=""/>
                      </div>
                      <div class="sx-info  p-t20 text-white">
                              
                      </div>                                          
                 </div>
              </div>
              
              <div class="item">
                  <div class="sx-box   image-hover-block">
                      <div class="sx-thum-bx">
                          <img src={rajpurafactory3} alt=""/>
                      </div>
                      <div class="sx-info  p-t20 text-white">
              
                      </div>
                     {/* <a class="mfp-link" href="img/infrastructure/rajpura-factory3.jpg">
                          <i class="fa fa-arrows-alt"></i>
                      </a>                                        
                 </div>
              </div>
              
              <div class="item">
                  <div class="sx-box   image-hover-block">
                      <div class="sx-thum-bx">
                          <img src={rajpurafactory4} alt=""/>
                      </div>
                      <div class="sx-info  p-t20 text-white">
              
                  
                      </div>
                                                      
                 </div>
              </div>
              
              <div class="item">
                  <div class="sx-box   image-hover-block">
                      <div class="sx-thum-bx">
                          <img src={rajpurafactory5} alt=""/>
                      </div>
                      <div class="sx-info  p-t20 text-white">
             
                      </div>                                          
                 </div>
              </div>
              
              <div class="item">
                  <div class="sx-box   image-hover-block">
                      <div class="sx-thum-bx">
                          <img src={rajpurafactory6} alt=""/>
                      </div>
                      <div class="sx-info  p-t20 text-white">
                 
                      </div>                                          
                 </div>
              </div>
              
              <div class="item">
                  <div class="sx-box   image-hover-block">
                      <div class="sx-thum-bx">
                          <img src={rajpurafactory7} alt=""/>
                      </div>
                      <div class="sx-info  p-t20 text-white">
              
                            
                      </div>                                          
                 </div>
              </div>
              
              <div class="item">
                  <div class="sx-box   image-hover-block">
                      <div class="sx-thum-bx">
                          <img src={rajpurafactory8} alt=""/>
                      </div>
                      <div class="sx-info  p-t20 text-white">
                
                      </div>                                          
                 </div>
              </div>
              
              <div class="item">
                  <div class="sx-box   image-hover-block">
                      <div class="sx-thum-bx">
                          <img src={rajpurafactory9} alt=""/>
                      </div>
                      <div class="sx-info  p-t20 text-white">
              
                      </div>                                           
                 </div>
              </div>   
              
              <div class="item">
                  <div class="sx-box   image-hover-block">
                      <div class="sx-thum-bx">
                          <img src={rajpurafactory10} alt=""/>
                      </div>
                      <div class="sx-info  p-t20 text-white">
                
                      </div>                                          
                 </div>
              </div>                                                                                                                            
           </div>
      </div> 
   </div>
     </div>
 </div>*/}           

  <div className="section-full mobile-page-padding p-t80 p-b50 bg-gray">
    <div className="container">
      <div className="section-head">
        <div className="sx-separator-outer separator-left">
          <div
            className="sx-separator bg-white bg-moving bg-repeat-x"
            style={{
              backgroundImage: "url(images/background/cross-line2.png)"
            }}
          >
            <h3 className="sep-line-one">Our Lighting Experience Center</h3>
          </div>
        </div>
      </div>
      <div className="section-content">
        <div className="row">
          <div className="col-xl-6 col-lg-6 col-md-12">
            <div className="video-section-full-v2">
              <div
                className="video-section-full bg-no-repeat bg-cover bg-center overlay-wraper m-b30"
                style={{
                  backgroundImage:
                    `url(${chandigarhshowroom})`
                }}
              >
                <div className="overlay-main bg-black opacity-04" />
                <div className="video-section-inner">
                  <div className="video-section-content">
                    <a
                      href={chandigarhvideo}
                      className="mfp-video play-now"
                      target='_blank'
                    >
                      <i className="icon fa fa-play" />
                      <span className="ripple" />
                    </a>
                    <div className="video-section-bottom">
                      <h3 className="sx-title text-white">
                        Chandigarh
                        <br />
                       Showrooms
                      </h3>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-6 col-lg-6 col-md-12">
            <div className="video-section-full-v2">
              <div
                className="video-section-full bg-no-repeat bg-cover bg-center overlay-wraper m-b30"
                style={{
                  backgroundImage:  `url(${mohalishowroom})`
                }}
              >
                <div className="overlay-main bg-black opacity-04" />
                <div className="video-section-inner">
                  <div className="video-section-content">
                    <a
                      href={mohalivideo}
                      className="mfp-video play-now"
                      target='_blank'
                    >
                      <i className="icon fa fa-play" />
                      <span className="ripple" />
                    </a>
                    <div className="video-section-bottom">
                      <h3 className="sx-title text-white">
                        Mohali
                        <br />
                        Showrooms
                      </h3>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
 
  <div class="container1">
        <a href="https://g.co/kgs/8s8yCVE" class="visit-us-btn">Visit Us</a>
       
        <a href="https://g.co/kgs/vpr1cdJ" class="visit-us-btn1">Visit Us</a>
        
    </div>
    <br></br>


{/*

  <div
    className="section-full  mobile-page-padding bg-gray  p-t80 p-b50 bg-repeat"
    style={{ backgroundImage: "url(images/background/bg-12.jpg)" }}
  >
    <div className="container">

      <div className="section-head">
        <div className="sx-separator-outer separator-left">
          <div
            className="sx-separator bg-white bg-moving bg-repeat-x"
            style={{
              backgroundImage: "url(images/background/cross-line2.png)"
            }}
          >
            <h3 className="sep-line-one">Our Customers</h3>
          </div>
        </div>
      </div>
       TITLE END 
      <div className="section-content">
        <div className="client-grid">
          <div className="row justify-content-center">
            <div className="col-lg-3 col-md-4 col-sm-6 m-b30">
              <a href="javascript:;" className="client-logo-pic">
                <img src="img/clients/33.png" alt="" />
                <div>
                  <span>ISB</span>
                </div>
              </a>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6  m-b30">
              <a href="javascript:;" className="client-logo-pic">
                <img src="img/clients/34.png" alt="" />
                <div>
                  <span>ELANTE</span>
                </div>
              </a>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6  m-b30">
              <a href="javascript:;" className="client-logo-pic">
                <img src="img/clients/37.png" alt="" />
                <div>
                  <span>CP</span>
                </div>
              </a>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6  m-b30">
              <a href="javascript:;" className="client-logo-pic">
                <img src="img/clients/39.png" alt="" />
                <div>
                  <span>HAVELI</span>
                </div>
              </a>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6  m-b30">
              <a href="javascript:;" className="client-logo-pic">
                <img src="img/clients/47.png" alt="" />
                <div>
                  <span>JLL</span>
                </div>
              </a>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6  m-b30">
              <a href="javascript:;" className="client-logo-pic">
                <img src="img/clients/53.png" alt="" />
                <div>
                  <span>MINCHYS</span>
                </div>
              </a>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6  m-b30">
              <a href="javascript:;" className="client-logo-pic">
                <img src="img/clients/61.png" alt="" />
                <div>
                  <span>TOREX</span>
                </div>
              </a>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6  m-b30">
              <a href="javascript:;" className="client-logo-pic">
                <img src="img/clients/83.png" alt="" />
                <div>
                  <span>ALKEM</span>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className="hilite-title text-left p-l50 text-uppercase">
      <strong>Clients</strong>
    </div>
  </div>*/}
</div>

  );}

  export default Ourinfrastructure;